import * as React from "react";
import { Async, Option, Options } from "react-select";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";

interface Props {
    value?: Option;
    onItemSelect?: (value: Option | null) => void;
    tabIndex?: number;
}

interface State {
    value?: Option;
}

export default class ProductSelect extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            value: props.value,
        };

        this.getProducts = this.getProducts.bind(this);
        this.filterProducts = this.filterProducts.bind(this);
        this.handleValueChanged = this.handleValueChanged.bind(this);
    }

    public render() {
        return <div>
            <Async
                value={this.state.value || undefined}
                onChange={this.handleValueChanged}
                placeholder=""
                isLoading={true}
                loadOptions={this.getProducts}
                filterOptions={this.filterProducts}
                tabIndex={this.props.tabIndex ? String(this.props.tabIndex) : undefined}
            />
        </div>;
    }

    public get value() {
        return this.state.value as Option | undefined;
    }

    public set value(value: Option | undefined) {
        this.setState({
            value: value,
        });
    }

    //private handleValueChanged(newValue: Option | null) {
    //    this.setState({
    //        value: newValue as Option,
    //    });

    //    if (this.props.onItemSelect !== undefined) {
    //        this.props.onItemSelect!(newValue);
    //    }
    //}
    private async handleValueChanged(newValue: Option | null) {

        this.setState({
            value: newValue as Option,
        });
        /* debugger;*/
        if (newValue?.isKit) {
            const response = await apifetch(`products/${newValue.value}/children`, undefined, true);
            if (response.ok) {
                const kitChildren = await response.json();
                newValue.kitChildren = kitChildren;

                if (this.props.onItemSelect) {
                    this.props.onItemSelect!(newValue);
                }

                this.setState({
                    value: undefined,
                });
            }
        } else {
            if (this.props.onItemSelect) {
                this.props.onItemSelect!(newValue);
            }
        }
    }

    private async getProducts(input: string) {
        if (!input) {
            return {
                options: [],
            };
        }

        let response = await apifetch(`products/search?query=${encodeURIComponent(input)}`, undefined, true);
        if (response.ok) {
            let data = await response.json();
            return {
                options: data.map((x: { id: number, name: string, unitMeasurement: string, isKit: boolean }) => ({
                    value: x.id,
                    label: x.name,
                    unitMeasurement: x.unitMeasurement,
                    isKit: x.isKit,
                })),
            };
        } else {
            console.error(await extractErrorMessage(response));
        }
    }

    private filterProducts(options: Options, filter: string, currentValues: Options) {
        return options;
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/common/ProductSelect.tsx